var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_vm._m(0),_c('ul',_vm._l((_vm.columnList),function(item,index){return _c('li',{key:index,staticClass:"flex"},[_c('span',{staticClass:"flex-box",on:{"click":function($event){return _vm.navHandle(item.strId)}}},[_vm._v(_vm._s(item.strName))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("快速导航")])])
}]

export { render, staticRenderFns }